import { Stack, Typography } from "@mui/material";
import React from "react";

const Header = ({ title, subtitle, mode, ...props }) => {
  return (
    <Stack {...props}>
      <Typography
        variant="h4"
        color={mode === "light" ? "black" : "#f6f6f6"}
        fontWeight={700}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="h5" color={"#9CA3AF"}>
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
};

export default Header;
